var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 282,
    viewBox: "0 0 282 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cambio_Contrasena 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 250,
    height: 250,
    rx: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M153.415 108.037C153.415 101.135 149.735 94.7607 143.757 91.3183C137.779 87.8672 130.419 87.8672 124.45 91.3183C118.472 94.7695 114.792 101.144 114.792 108.037V117.748V126.535H107.071V117.73V108.037C107.071 98.3792 112.221 89.4519 120.585 84.6185C128.949 79.7938 139.249 79.7938 147.622 84.6185C155.986 89.4519 161.136 98.3704 161.136 108.037V118.611V120.372H153.406V118.611V108.037H153.415Z",
    fill: "url(#paint0_linear_1_5204)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M138.871 139.943C136.485 138.552 133.536 138.543 131.141 139.917C128.738 141.29 127.267 143.843 127.259 146.608C127.259 149.372 128.729 151.926 131.124 153.308V165.968C131.124 168.099 132.849 169.833 134.988 169.833C137.128 169.833 138.853 168.107 138.853 165.968V153.308C141.231 151.934 142.71 149.399 142.718 146.652C142.736 143.887 141.266 141.325 138.88 139.934L138.871 139.943Z",
    fill: "url(#paint1_linear_1_5204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M165.882 119.623H104.086C97.6856 119.623 92.5 124.809 92.5 131.21V177.554C92.5 183.955 97.6856 189.14 104.086 189.14H165.882C172.282 189.14 177.468 183.955 177.468 177.554V131.21C177.468 124.809 172.273 119.623 165.882 119.623ZM169.747 177.554C169.747 178.575 169.342 179.561 168.62 180.283C167.898 181.005 166.912 181.41 165.891 181.41H104.095C101.964 181.41 100.23 179.685 100.23 177.545V131.201C100.23 129.07 101.956 127.336 104.095 127.336H165.891C166.912 127.336 167.898 127.741 168.62 128.463C169.342 129.185 169.747 130.171 169.747 131.192V177.536V177.554Z",
    fill: "url(#paint2_linear_1_5204)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M173.5 201C183.717 201 192 192.717 192 182.5C192 172.283 183.717 164 173.5 164C163.283 164 155 172.283 155 182.5C155 192.717 163.283 201 173.5 201Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M200.93 179.369C200.028 179.392 199.177 179.764 198.569 180.413L197.779 181.204C196.932 168.691 186.491 158.77 173.774 158.77C167.009 158.77 160.539 161.623 156.026 166.6C154.732 168.009 154.844 170.201 156.25 171.492L156.253 171.494C157.663 172.779 159.854 172.674 161.142 171.268L160.405 170.592L161.141 171.269C164.415 167.706 169.026 165.672 173.774 165.672C182.599 165.672 189.886 172.398 190.782 180.998L190.122 180.339C189.45 179.666 188.495 179.277 187.571 179.307C186.661 179.325 185.814 179.708 185.212 180.35C184.542 181.021 184.17 181.944 184.193 182.885C184.209 183.797 184.593 184.647 185.236 185.251L191.9 191.92C192.571 192.592 193.41 192.952 194.346 192.952C195.289 192.952 196.224 192.586 196.822 191.89L203.433 185.275C204.094 184.659 204.475 183.823 204.499 182.924L204.499 182.924L204.499 182.915C204.508 182.422 204.41 181.943 204.218 181.501L204.46 181.38L203.48 180.4C202.79 179.709 201.9 179.383 200.971 179.368L200.95 179.368L200.93 179.369Z",
    fill: "url(#paint3_linear_1_5204)",
    stroke: "#F9F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M173.954 199.851C165.234 199.851 158.022 193.161 157.124 184.59L157.748 185.22C157.749 185.22 157.749 185.22 157.749 185.221C159.108 186.597 161.26 186.601 162.616 185.22C163.284 184.546 163.659 183.627 163.635 182.679L163.635 182.678C163.612 181.783 163.247 180.933 162.602 180.328L156.006 173.618L156.006 173.618L156.001 173.613C154.694 172.303 152.446 172.291 151.133 173.615L151.133 173.615L151.13 173.618L144.52 180.343C143.853 181.016 143.479 181.934 143.501 182.881C143.517 183.788 143.896 184.636 144.533 185.239C145.186 185.896 146.074 186.26 146.981 186.26H147.031H147.04L147.049 186.26C147.959 186.244 148.805 185.859 149.404 185.215L150.168 184.444C151.016 196.914 161.35 206.808 173.948 206.808C180.653 206.808 187.063 203.96 191.534 198.994C192.806 197.598 192.71 195.424 191.347 194.146C190.717 193.524 189.791 193.099 188.867 193.159C187.946 193.185 187.071 193.596 186.455 194.27C183.213 197.819 178.65 199.851 173.954 199.851Z",
    fill: "url(#paint4_linear_1_5204)",
    stroke: "#F9F9F9",
    strokeWidth: 2
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5204",
    x1: 156.796,
    y1: 87.1012,
    x2: 97.8703,
    y2: 142.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2093FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_5204",
    x1: 124.67,
    y1: 143.993,
    x2: 149.277,
    y2: 167.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2093FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_5204",
    x1: 93.7854,
    y1: 115.811,
    x2: 192.928,
    y2: 208.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2093FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_5204",
    x1: 113.462,
    y1: 112.396,
    x2: 202.292,
    y2: 195.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2093FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_5204",
    x1: 100.451,
    y1: 127.334,
    x2: 189.023,
    y2: 209.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2093FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/ChangePassword.aec07fd3dc76d6e8e3fcb00857be95eb.svg";
export { ForwardRef as ReactComponent };